import { createAction, createApiAction } from 'store';
import * as types from './ActionTypes';

export const postNewClient = createApiAction(types.POST_NEW_CLIENT);
export const getClientList = createApiAction(types.GET_CLIENT_LIST);
export const updateClientList = createApiAction(types.UPDATE_CLIENT_LIST);

export const getClientDetails = createApiAction(types.GET_CLIENT_DETAILS);
export const deleteClient = createApiAction(types.DELETE_CLIENT);

export const getClientData = createApiAction(types.GET_CLIENT_DATA);
export const updateClientData = createApiAction(types.UPDATE_CLIENT_DATA);

export const getClientUsers = createApiAction(types.GET_CLIENT_USERS);
export const getPartnerLimits = createApiAction(types.GET_PARTNER_LIMITS);

export const getClientSurveyData = createApiAction(
	types.GET_CLIENT_SURVEY_DATA,
);

export const resetClientList = createAction(types.RESET_CLIENT_LIST);

export const resetClientDetails = createAction(types.RESET_CLIENT_DETAILS);
export const resetClientError = createAction(types.RESET_CLIENT_ERROR);

export const resetClientData = createAction(types.RESET_CLIENT_DATA);
export const resetUpdateClientData = createAction(
	types.RESET_UPDATE_CLIENT_DATA,
);

export const resetNewClient = createAction(types.RESET_NEW_CLIENT);
export const createClientNewUser = createApiAction(types.CREATE_CLIENT_USER);
export const resetClientNewUser = createAction(types.RESET_CLIENT_NEW_USER);

export const resetIsClientDeleted = createAction(types.RESET_IS_CLIENT_DELETED);
